import { render } from "./ServiceSection.vue?vue&type=template&id=d719e72e"
import script from "./ServiceSection.vue?vue&type=script&lang=js"
export * from "./ServiceSection.vue?vue&type=script&lang=js"

import "./ServiceSection.vue?vue&type=style&index=0&id=d719e72e&lang=css"

import exportComponent from "/home/beatriz/Documents/GitHub/virtus_consult/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__